"use client"

import { useEffect, useRef, useState } from "react"
import { Card } from "react-bootstrap"
import CustomModal from "../../utils/modals/CustomModal"
import { useDispatch, useSelector } from "react-redux"
import FormEditLeadGenerate from "./components/FormEditLeadGenerate"
import HeaderChips from "./components/HeaderChips"
import Icons from "../../utils/Icons"
import FullScreenModal from "../../utils/modals/FullScreenModal"
import PersonalCard from "../../card/PersonalCard"
import LeadCard from "../../card/LeadCard"
import { OrdertFilter, OrdertFilterExpert } from "../../utils/TeamsData"
import { getOrderMessageListAction, requestForAssignLeadAction } from "../../../services/action/common"
import RangeDateFilter from "./components/RangeDateFilter"
import AssignExpert from "./components/assign-to-expert/AssignExpert"
import RequestLeadId from "./components/expert/RequestLeadId"
import CustomDataTable from "../../utils/data-tables/CustomDataTable"
import { ColumnOrderList } from "./components/ColumnOrderList"
import Buttons from "../../utils/buttons/Buttons"
import { handlePopupModalAction } from "../../../services/action/event"
import { Menu } from "lucide-react"
import { getLeadsAction } from "../../../services/action/manager"
import ResultForm from "./components/result/ResultForm"

const OrderListComponent = ({
  // getList,
  // TeamsData,
  // listTitle = "Lead List",
  isOpenLeadOnly = false,
  // pageData,
  // setPageData,
  // setFilter,
  // filter,
  // getAllLiveUser,
  // setDateRanges = {},
  // dateRanges = {},
}) => {


  
  const { user } = useSelector((state) => state.authenticationReducer)
  const { leads:TeamsData } = useSelector((state) => state.managerReducer);
  const [search,setSearch]=useState("")
  const [pageData, setPageData] = useState({
    page: 1,
    limit: 15,
  });

    const [result, setResult] = useState({
      modal: false,
      data: "",
    });

  const [filters, setFilter] = useState(["ALL_ORDERS"]);
    const initialDate={
      clientStartDate: null,
      clientEndDate: null,
      expertStartDate: null,
      expertEndDate: null,
      leadStartDate: null,
      leadEndDate: null,
    }
    const [dateRanges, setDateRanges] = useState(initialDate);
  
    
  
  
    const getList = ({
      currentPage = pageData?.page,
      firstTime = false,
      isEmptylist = true,
      tempSearch = search,
      filter = filters,
      sortConfig,
      dateFilter=dateRanges,
      tempUserType=user?.userType,
      tempResultFilter=resultFilter
    }) => {
      dispatch(
        getLeadsAction({
          userType: tempUserType,
          firstTime,
          data: {
            sortConfig,
            search:tempSearch,
            page: currentPage,
            isEmptylist,
            dateFilter: {
              clientDeadline: { startDate: dateFilter.clientStartDate, endDate: dateFilter.clientEndDate },
              expertDeadline: { startDate: dateFilter.expertStartDate, endDate: dateFilter.expertEndDate },
              leadRegistration: { startDate: dateFilter.leadStartDate, endDate: dateFilter.leadEndDate },
            },
            result:resultFilter,
            orderStatus: filter,
          },
        })
      );
    };
    
    useEffect(() => {
      if(user?.userType){
      getList({ currentPage: 1, firstTime: true ,tempUserType:user?.userType});
      }
    }, [user?.userType]);

    const onSearch=(value) => {
        setPageData({page:1})
        setSearch(value)
        getList({ tempSearch: value,firstTime:true,currentPage:1})
      }


  const [leadDetails, setLeadDetails] = useState({
    modal: false,
    edit: false,
    preview: false,
    data: "",
  })

  const [hideAppliedLead, setHideApplied] = useState(false)
  const exportInExcelRef = useRef()

  const [showExpertAssign, setShowExpertAssign] = useState("")
  const [clientId, setClientId] = useState("")
  const [expertId, setExpertId] = useState("")
  const [leadId, setLeadId] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  const [resultFilter, setResultFilter] = useState(null)

  const [requestLeadId, setRequestLeadId] = useState("")
  const dispatch = useDispatch()
  const isExpert = user?.userType === "EXPERT"

  const afterSave = () => {
    setLeadDetails({})
    setPageData({ page: 1 })
    getList({ currentPage: 1, filter:filters, firstTime: true })
  }

  const onSelectFilter = (filter) => {
    setPageData({ page: 1 })
    getList({ currentPage: 1, filter, firstTime: true })
  }

  const isMangerOrOperator =
    user?.userType === "OPERATOR" ||
    user?.userType === "MANAGER" ||
    user?.userType === "ADMIN" ||
    user?.userType === "SUPER_ADMIN"

  const isAccounts= user?.userType === "ACCOUNTS";
  const isMangerOrAdmin = user?.userType === "MANAGER" || user?.userType === "ADMIN" || user?.userType === "SUPER_ADMIN"

  const fetchMoreData = () => {
    setPageData({ page: pageData?.page + 1 })
    getList({ currentPage: pageData?.page + 1, firstTime: false })
  }

  const startChat = (item) => {
    dispatch(getOrderMessageListAction({ data: { leadId: item?.leadDetail?._id } }))
  }

  const removeFromRequestExpert = (lead) => {
    dispatch(
      requestForAssignLeadAction({
        userType: user?.userType?.toLowerCase(),
        data: {
          leadId: lead?._id,
          expertId: user?._id,
          comment: "Remove",
        },
        cb: () => {
          setRequestLeadId("")
          afterSave()
        },
      }),
    )
  }
  return (
    <Card className="h-full w-full shadow-md rounded-lg overflow-hidden">
      <FullScreenModal
        title={"Personal Details"}
        bgContent="dark-bg"
        size="xl"
        open={clientId}
        onClose={() => setClientId("")}
        content={() => (
          <PersonalCard
            hideAction={true}
            onDeleteClick={(_) => {}}
            onEditClick={(_) => {}}
            data={clientId}
            close={() => setClientId("")}
          />
        )}
      />
      <CustomModal
        open={showExpertAssign}
        onClose={() => setShowExpertAssign("")}
        content={() => (
          <AssignExpert
            openLead={showExpertAssign}
            showMailOption={true}
            onClose={() => {
              setShowExpertAssign("")
              afterSave()
            }}
          />
        )}
      />

      <CustomModal
        open={requestLeadId}
        onClose={() => setRequestLeadId("")}
        headerShown={false}
        content={() => (
          <RequestLeadId
            lead={requestLeadId}
            onClose={() => {
              setRequestLeadId("")
              afterSave()
            }}
          />
        )}
      />

      <FullScreenModal
        title={"Personal Details"}
        bgContent="dark-bg"
        size="xl"
        open={expertId}
        onClose={() => setExpertId("")}
        content={() => (
          <PersonalCard
            hideAction={true}
            onDeleteClick={(_) => {}}
            onEditClick={(_) => {}}
            data={expertId}
            close={() => setExpertId("")}
          />
        )}
      />

      <FullScreenModal
        title={"Personal Details"}
        bgContent="dark-bg"
        size="xl"
        open={leadId}
        onClose={() => setLeadId("")}
        content={() => (
          <LeadCard
            hideAction={true}
            onDeleteClick={(_) => {}}
            onEditClick={(data) => setLeadDetails({ edit: true, data, modal: true })}
            data={leadId}
            close={() => setLeadId("")}
          />
        )}
      />
      <CustomModal
        title={"Generate Lead"}
        bgContent="dark-bg"
        open={leadDetails.modal}
        onClose={() => setLeadDetails({})}
        content={() => (
          <FormEditLeadGenerate page={leadDetails?.data ? "order" : ""} data={leadDetails?.data} close={afterSave} />
        )}
      />
      

      <Card.Header className="bg-white py-4 px-4 md:px-6 flex flex-wrap items-center justify-between border-b">
        <div className="flex items-center space-x-2">
          <button
            onClick={() => dispatch(handlePopupModalAction({ isOpenSidebar: true }))}
            className="p-2 hover:text-white rounded-md hover:bg-[#0A2547] transition-colors lg:hidden"
          >
            <Menu className="w-6 h-6" />
          </button>
          <h4 className="text-lg font-semibold mb-0 flex flex-wrap items-center gap-2">
            {"Order List"}

            {isOpenLeadOnly && (
              <Buttons
                size="small"
                onClick={() => setHideApplied(!hideAppliedLead)}
                title={hideAppliedLead ? "Show Applied" : "Hide Applied"}
              />
            )}

            {!isOpenLeadOnly && (
              <>
                <span
                  className={`filter-icon cursor-pointer p-1 rounded hover:bg-gray-100 ${showFilter ? "text-blue-600" : ""}`}
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <Icons title={"filter"} />
                </span>
                <div className="relative ml-2 hidden md:block">
                  <input
                    type="text"
                    placeholder="Search leads..."
                    value={search}
                    onChange={(e) => onSearch(e?.target?.value)}
                    className="pl-8 pr-4 py-1 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 w-48"
                  />
                  <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <Icons title={"search"} />
                  </span>
                </div>
              </>
            )}
          </h4>
        </div>

        <div className="flex flex-wrap items-center gap-2 mt-2 sm:mt-0">
          <div className="relative md:hidden w-full mb-2">
            <input
              type="text"
              placeholder="Search leads..."
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              className="pl-8 pr-4 py-1 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 w-full"
            />
            <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400">
              <Icons title={"search"} />
            </span>
          </div>

          {(isMangerOrOperator  || isAccounts) && (
            <RangeDateFilter
            resultFilter={resultFilter}
            setResultFilter={setResultFilter}
              setPageData={setPageData}
              getList={getList}
              filter={filters}
              setDateRanges={setDateRanges}
              dateRanges={dateRanges}
            />
          )}

          {isMangerOrAdmin && <Buttons title={"Excel"} onClick={() => exportInExcelRef.current?.click()} />}

         {isMangerOrOperator && <Buttons onClick={() => setLeadDetails({ modal: true, edit: false })} title={"Add New Leads"} icon="plus" />}
        </div>
      </Card.Header>

      {(!isOpenLeadOnly || isAccounts) && (
        <div className="px-4 md:px-6">
          <HeaderChips
            list={isExpert ? OrdertFilterExpert : OrdertFilter}
            onSelectFilter={onSelectFilter}
            filter={filters}
            setFilter={setFilter}
            showFilter={showFilter}
          />
        </div>
      )}
<FullScreenModal
        title={"Result"}
        bgContent="dark-bg"
        open={result.modal}
        onClose={() => setResult({})}
        size="md"
        headerShown={false}
        content={() => (
          <ResultForm
            data={result.data}
            disableField={!isMangerOrOperator}
            close={() => setResult({})}
            onSuccess={()=>{
              afterSave()
              setResult({})
            }}
          />
        )}
      />
      <div className="flex-grow overflow-hidden">
        <CustomDataTable
          columns={ColumnOrderList(
            startChat,
            afterSave,
            setShowExpertAssign,
            isOpenLeadOnly,
            user,
            setClientId,
            setRequestLeadId,
            removeFromRequestExpert,
            isMangerOrAdmin,
            setResult
          )}
          downLoadBtnRef={exportInExcelRef}
          isInfinitScroll={true}
          fetchMoreData={fetchMoreData}
          data={hideAppliedLead ? TeamsData?.data?.filter((item) => !item?.expertRequest) : TeamsData?.data}
        />
      </div>
    </Card>
  )
}

export default OrderListComponent

